import {createAction} from '@ngrx/store';

export const toggleSidebar = createAction(
  '[UI] toggle sidebar'
);
